<template>
    <div class="warpper">
        <div class="top">
            <!-- 功能按钮 -->
            <div class="top_operate">
                <div style="display: flex; align-items: center">
                    <img
                        src="@/assets/img/last1.png"
                        style="width: 30px; transform: rotate(180deg)"
                        :class="nullBtn || !last ? 'gray' : ''"
                        alt=""
                        @click="!isEdit || nullBtn ? '' : changeOrder(1)"
                    />
                    <img
                        src="@/assets/img/next1.png"
                        style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                        :class="nullBtn || !last ? 'gray' : ''"
                        alt=""
                        @click="!isEdit || nullBtn ? '' : changeOrder(2)"
                    />
                    <img
                        src="@/assets/img/next1.png"
                        style="width: 30px; margin-right: 15px"
                        :class="nullBtn || !first ? 'gray' : ''"
                        alt=""
                        @click="!isEdit || nullBtn ? '' : changeOrder(3)"
                    />
                    <img
                        src="@/assets/img/last1.png"
                        style="width: 30px"
                        :class="nullBtn || !first ? 'gray' : ''"
                        alt=""
                        @click="!isEdit || nullBtn ? '' : changeOrder(4)"
                    />
                    <!-- <el-button type="warning" style="margin-left: 10px" icon="el-icon-refresh" size="mini" @click="outData.isshow = true"
                        >{{ $t('common.filter') }}</el-button
                    >
                    <el-button type="success" style="margin-left: 10px" icon="el-icon-download" size="mini" @click="showOut"
                        >导出
                    </el-button>
                    <div style="margin-left: 10px">
                        <el-button :disabled="!isEdit" type="warning" size="mini" @click="checkData.isshow = true" plain
                            >批量审核
                        </el-button>
                    </div> -->
                </div>
                <div>
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-printer"
                        :disabled="!isEdit || nullBtn"
                        @click="labelClick"
                        v-if="perData.allow_add == 1"
                        >{{ $t('common.label') }}</el-button
                    >
                    <el-button type="primary" size="mini" :disabled="nullBtn || isEdit" @click="serial()">{{ $t('common.electronicScale') }}</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-plus" v-if="perData.allow_add == 1" :disabled="!isEdit" @click="add"
                        >{{ $t('common.add') }}</el-button
                    >
                    <el-button
                        type="warning"
                        size="mini"
                        icon="el-icon-edit"
                        v-if="perData.allow_edit == 1"
                        @click="edit"
                        :disabled="!isEdit || isCheck || nullBtn"
                        >{{ $t('common.edit') }}</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        v-if="perData.allow_dele == 1"
                        :disabled="!isEdit || isCheck || nullBtn"
                        @click="deleteIt"
                        >{{ $t('common.delete') }}</el-button
                    >
                    <el-button type="info" size="mini" @click="goHistory" :disabled="!isEdit">{{ $t('common.historyBill') }}</el-button>

                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-printer"
                        v-if="perData.allow_print == 1"
                        :disabled="!isEdit || nullBtn"
                        @click="printOut"
                        >{{ $t('common.print') }}</el-button
                    >
                    <el-button
                        type="primary"
                        :disabled="!isEdit || nullBtn"
                        v-if="perData.allow_check == 1"
                        size="mini"
                        plain
                        @click="check()"
                        >{{ form.check == 1 ? $t('common.cancelAudit') : $t('common.audit') }}</el-button
                    >
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-setting"
                        v-if="perData.allow_print == 1"
                        :disabled="!isEdit"
                        @click="showModuleParamSet"
                    ></el-button
                    >
                </div>
            </div>
            <!-- 制单信息 -->
            <div class="top_col">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{
                                form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                            }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 单据主表 -->
            <div class="top_cols">
                <el-form>
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.billNo') + '：'">
                                    <el-input placeholder="" v-model="form.salesj_no" :disabled="true"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.billDate') + '：'" required>
                                    <!-- <el-input placeholder="" v-model="form.salesj_date" :disabled="true"></el-input> -->
                                    <el-date-picker
                                        type="datetime"
                                        :disabled="isEdit"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期"
                                        v-model="form.salesj_date"
                                        @change="billDateChange"
                                        style="width: 100%"
                                    ></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.customer') + '：'" required>
                                    <mySelectOptimized
                                        v-model="form.cust_no"
                                        :options="pullData.cust"
                                        values="cust_no"
                                        labels="cust_name"
                                        keys="cust_no"
                                        :disable="isEdit"
                                        @input="selectCust"
                                        @selectChange="selectCustChange"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.billType') + '：'" required>
                                    <mySelect
                                        v-model="form.billtype_no"
                                        :options="pullData.billtype"
                                        values="billtype_no"
                                        labels="billtype_name"
                                        keys="billtype_no"
                                        :disable="isEdit"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.counter') + '：'" required>
                                    <mySelect
                                        v-model="form.counter_no"
                                        :options="pullData.counter"
                                        values="counter_no"
                                        labels="counter_name"
                                        keys="counter_no"
                                        :disable="isEdit"
                                        @input="changeCounter"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.salesman') + '：'">
                                    <mySelect
                                        v-model="form.salesman_no"
                                        :options="pullData.salesman"
                                        values="salesman_no"
                                        labels="salesman_name"
                                        keys="salesman_no"
                                        :disable="isEdit"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="input_col">
                                <el-form-item :label="$t('common.currency') + '：'" required>
                                    <mySelect
                                        v-model="form.currency_no"
                                        :options="pullData.currency"
                                        values="currency_no"
                                        labels="currency_name"
                                        keys="currency_no"
                                        :disable="isEdit"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4" v-if="systemSet.isstores == 1">
                            <div class="input_col">
                                <el-form-item :label="$t('common.store') + '：'">
                                    <mySelect
                                        v-model="form.store_no"
                                        :options="pullData.store"
                                        values="store_no"
                                        labels="store_name"
                                        keys="store_no"
                                        :disable="isEdit"
                                        :clearables="false"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="systemSet.isstores == 1 ? 16 : 20">
                            <div class="input_col">
                                <el-form-item :label="$t('common.remark') + '：'">
                                    <el-input
                                        type="textarea"
                                        :rows="1"
                                        v-model="form.remark"
                                        placeholder="请输入备注"
                                        :disabled="isEdit"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 会员信息 -->
            <div class="member-section" v-if="systemSet.isMember == 1">
                <el-form>
                    <div class="form-section">
                        <div class="section-title"><i class="el-icon-user"></i>会员信息</div>
                        <el-row :gutter="20">
                            <el-col :span="4">
                                <el-form-item label="手机号" prop="member_phone">
                                    <el-input v-model="form.member_phone" placeholder="输入后回车查询"
                                              :disabled="isEdit" @blur="getMemberData"
                                              @keyup.enter.native="getMemberData">
                                        <i slot="suffix" class="el-icon-search" style="cursor:pointer"
                                           @click="getMemberData"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="会员ID">
                                    <el-input v-model="form.member_id" disabled placeholder="自动带出"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="会员名称">
                                    <el-input v-model="form.member_name" disabled placeholder="自动带出"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="储值抵扣金额" prop="member_deduct_amt">
                                    <el-input v-model="form.member_deduct_amt" min="0" type="number" :disabled="isEdit"
                                              placeholder="请输入" @blur="foottotal">
                                        <el-button slot="append" :disabled="isEdit" @click="deductLaborFee">抵扣工费
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" v-if="form.member_balance && form.member_balance.length">
                                <el-form-item label="会员余额">
                                    <div class="member-balance">
                                        <span v-for="(item, idx) in form.member_balance" :key="idx"
                                              class="balance-item">
                                            {{ item.currency_no }}-{{ item.currency_name }}: {{ item.amt }}
                                        </span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
        </div>
        <!-- 引用单据 -->
        <div class="inbound">
            <div class="title" @click="shouinbound = !shouinbound">
                <div>
                    引用单据
                    <i class="el-icon-caret-right" v-if="!shouinbound"></i>
                    <i class="el-icon-caret-bottom" v-else></i>
                </div>
                <el-button type="primary" @click.stop="sureInbound" v-if="shouinbound && !isEdit">确认</el-button>
            </div>
            <div class="table" v-show="shouinbound">
                <vxe-table border ref="orderTable" auto-resize height="290" :data="form.bring">
                    <vxe-table-column type="checkbox" width="50" v-if="!isEdit"> </vxe-table-column>
                    <vxe-table-column title="序号" type="seq" field="seq" width="50" align="center"></vxe-table-column>
                    <vxe-table-column title="单据类型" field="billtype_name" width="150"></vxe-table-column>
                    <vxe-table-column title="单号" field="no" width="150"></vxe-table-column>
                    <vxe-table-column title="供应商" field="cust_name" width="150"></vxe-table-column>
                    <vxe-table-column title="柜台" field="counter_name" width="150"></vxe-table-column>
                    <vxe-table-column title="数量" field="sumqty" width="150"></vxe-table-column>
                    <vxe-table-column title="重量" field="sumwgt" width="150"></vxe-table-column>
                    <vxe-table-column title="备注" field="remark" min-width="300"></vxe-table-column>
                </vxe-table>
            </div>
        </div>
        <div>
            <!-- 货品明细 -->
            <div class="table1" @mouseleave="dtlleave">
                <div class="title">
                    <p>{{ $t('common.productDetail') }}</p>
                    <div>
                        <el-button type="" :disabled="isEdit" @click="closingCopy()">复制</el-button>
                        <el-button type="" :disabled="isEdit" @click="closingPrice(1)">{{ $t('common.allPriceSettlement') }}</el-button>
                        <el-button type="" :disabled="isEdit" @click="closingPrice(2)">{{ $t('common.allMaterialSettlement') }}</el-button>
                        <el-button type="" :disabled="isEdit" @click="closingPrice(3)">{{ $t('common.sequentialPriceSettlement') }}</el-button>
                        <el-button type="" :disabled="isEdit" @click="closingPrice(4)">{{ $t('common.sequentialMaterialSettlement') }}</el-button>
                    </div>
                </div>
                <vxe-table
                    :height="maxHeight"
                    :data="form.dtl"
                    ref="dtlTable"
                    :row-class-name="rowChange"
                    resizable
                    stripe
                    :auto-resize="true"
                    border
                    :footer-method="footerMethod"
                    show-footer
                    footer-row-class-name="footclass"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    :keyboard-config="{
                        isArrow: true,
                        isDel: true,
                        isEdit: true
                    }"
                    :mouse-config="{ selected: true }"
                    @cell-mouseenter="dtlenter"
                    @checkbox-change="checkboxChangeEvent"
                    @checkbox-all="checkboxChangeEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                    <vxe-table-column type="seq" width="70" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isEdit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.seq == dtlIndex">
                                <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                                <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                            </span>
                            <span v-if="scoped.seq != dtlIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>
                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner',
                                events: { focus: myfocus }
                            }"
                            v-if="
                                item.column_status == 1 &&
                                item.column_type != 'select' &&
                                item.field != 'barcode' &&
                                item.field != 'itemno'
                            "
                            ><template #header="{ column }" v-if="item.batch == 1">
                                <span>{{ column.title }}</span>
                                <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                    <el-button class="batchBtn" type="primary" plain :disabled="isEdit" @click="batchclick">批量</el-button>
                                    <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                        <el-radio-group v-model="batchOption">
                                            <div style="display: flex">
                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="1">所有行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="2">选中行及以下行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="5">选中行修改为</el-radio>
                                                    </div>
                                                </div>

                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="3">所有行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="4">选中行及以下行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="6">选中行加减</el-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-radio-group>
                                        <div style="padding-top: 5px"></div>
                                        <el-form :inline="true">
                                            <el-form-item label="">
                                                <vxe-input
                                                    style="width: 280px"
                                                    :type="item.column_type"
                                                    v-model="batchSelect"
                                                    @blur="batchOperation($event, column.property)"
                                                ></vxe-input>
                                            </el-form-item>
                                        </el-form>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type, 'dtlTable')"
                                    :controls="false"
                                    @keydown.native="jumptable($event, row, item.field, 'dtlTable')"
                                    v-model="row[item.field]"
                                    @blur="handleBlur(row, item.field, item.column_type, 'dtlTable', item.tofixed)"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.field == 'barcode'"
                            :key="item.field + index"
                            :field="item.field"
                            :title="item.column_name"
                            :width="item.column_width"
                            :edit-render="{ name: 'input', attrs: { disabled: isEdit }, events: {} }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    v-model="row.barcode"
                                    @keydown.native="barcodeJump($event, row, 'barcode')"
                                    type="text"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.field == 'itemno'"
                            :key="item.field + index"
                            :field="item.field"
                            :title="item.column_name"
                            :width="item.column_width"
                            :edit-render="{ name: 'input', attrs: { disabled: isEdit }, events: {} }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    v-model="row.itemno"
                                    @keydown.native="getItemNoData($event, row,)"
                                    type="text"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        pullData[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in pullData[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                    </template>
                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 180px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
            <div class="table_warpper" @mouseleave="billleave">
                <!-- 账款明细 -->
                <div class="table2 table1">
                    <div class="title">
                        <p>{{ $t('common.accountDetail') }}</p>
                    </div>
                    <vxe-table
                        height="320"
                        :data="form.bill"
                        ref="billTable"
                        :footer-method="footerMethod1"
                        show-footer
                        footer-row-class-name="footclass"
                        resizable
                        stripe
                        :auto-resize="true"
                        border
                        @cell-mouseenter="billenter"
                        :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                        :mouse-config="{ selected: true }"
                        :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                        @edit-closed="editClosedEvent"
                        :key="refushTable"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" width="40" align="center">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isEdit ? changeTable(2) : null"></i>
                            </template>
                            <template slot-scope="scoped">
                                <span class="add_" v-if="scoped.seq == billIndex">
                                    <i class="el-icon-circle-plus-outline" @click="addbill"></i>
                                    <i class="el-icon-remove-outline" @click="delbill(scoped)"></i>
                                </span>
                                <span v-if="scoped.seq != billIndex">
                                    <i style="font-style: normal">{{ scoped.seq }}</i>
                                </span>
                            </template>
                        </vxe-table-column>
                        <template v-for="(item, index) in zkKeyList">
                            <vxe-table-column
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{
                                    name: 'input',
                                    attrs: { type: item.column_type },
                                    autoselect: true,
                                    autofocus: '.vxe-input--inner',
                                    events: { focus: myfocus }
                                }"
                                v-if="
                                    item.column_status == 1 &&
                                    item.column_type != 'select'
                                "
                            >
                                <template v-slot:edit="{ row }">
                                    <vxe-input
                                        type="text"
                                        @input="handleInput(row, item.field, item.column_type,'billTable')"
                                        @keydown.native="jumptable($event, row, item.field,'billTable')"
                                        v-model="row[item.field]"
                                        @blur="handleBlur(row, item.field, item.column_type, 'billTable', item.tofixed)"
                                    ></vxe-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{ autofocus: '.el-input__inner' }"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            pullData[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                                </template>
                                <template v-slot:edit="{ row }">
                                    <el-select
                                        size="mini"
                                        v-model="row[item.field]"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        @change="changeData(row, item.field.replace('_no', ''))"
                                        @keydown.native="jumptable($event, row, item.field)"
                                    >
                                        <el-option
                                            v-for="option in pullData[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </vxe-table-column>
                        </template>

                        <template #empty>
                            <span style="color: red">
                                <img src="@/assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
                <!-- 收付款明细 -->
                <div class="table3 table1" @mouseleave="amtleave">
                    <div class="title">
                        <p>{{ $t('common.paymentDetail') }}</p>
                        <div></div>
                    </div>
                    <vxe-table
                        height="320"
                        :data="form.amt"
                        ref="amtTable"
                        :footer-method="footerMethod2"
                        show-footer
                        resizable
                        stripe
                        :auto-resize="true"
                        border
                        :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                        @cell-mouseenter="amtenter"
                        :mouse-config="{ selected: true }"
                        :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" width="40" align="center">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isEdit ? changeTable(3) : null"></i>
                            </template>
                            <template slot-scope="scoped">
                                <span class="add_" v-if="scoped.$rowIndex == amtIndex">
                                    <i class="el-icon-circle-plus-outline" @click="addamt"></i>
                                    <i class="el-icon-remove-outline" @click="delamt(scoped)"></i>
                                </span>
                                <span v-if="scoped.$rowIndex != amtIndex">
                                    <i style="font-style: normal">{{ scoped.seq }}</i>
                                </span>
                            </template>
                        </vxe-table-column>
                        <template v-for="(item, index) in fkKeyList">
                            <vxe-table-column
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{
                                    name: 'input',
                                    attrs: { type: item.column_type },
                                    autoselect: true,
                                    autofocus: '.vxe-input--inner',
                                    events: { focus: myfocus }
                                }"
                                v-if="item.column_status == 1 && item.column_type != 'select'"
                            >
                                <template v-slot:edit="{ row }">
                                    <vxe-input
                                        type="text"
                                        @input="handleInput(row, item.field, item.column_type,'amtTable')"
                                        @keydown.native="jumptable($event, row, item.field,'amtTable')"
                                        v-model="row[item.field]"
                                        @blur="handleBlur(row, item.field, item.column_type, 'amtTable', item.tofixed)"
                                    ></vxe-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{ autofocus: '.el-input__inner' }"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            pullData[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                                </template>
                                <template v-slot:edit="{ row }">
                                    <el-select
                                        size="mini"
                                        v-model="row[item.field]"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        @change="changeData(row, item.field.replace('_no', ''))"
                                        @keydown.native="jumptable($event, row, item.field)"
                                    >
                                        <el-option
                                            v-for="option in pullData[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </vxe-table-column>
                        </template>
                        <template #empty>
                            <span style="color: red">
                                <img src="@/assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
                <!-- 客户存欠 -->
                <div class="table4 table1">
                    <div class="title">
                        <p>客户存欠（正欠负存）</p>
                    </div>
                    <vxe-table
                        height="320"
                        :data="form.custAccount"
                        ref="custAccountTable"
                        resizable
                        stripe
                        :auto-resize="true"
                        border
                        :mouse-config="{ selected: true }"
                        :scroll-y="{ enabled: true, gt: 50 }"
                        :row-style="rowStyleMethod"
                    >
                        <vxe-table-column title="账期" type="type" field="type" width="50" align="center"></vxe-table-column>
                        <vxe-table-column title="存欠项目" type="style_name" field="style_name" width="100" align="center"></vxe-table-column>
                        <vxe-table-column title="存欠值" type="value" field="value" width="200" align="center"></vxe-table-column>
                        <template #empty>
                            <span style="color: red">
                                <img src="@/assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
            </div>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.totalQty') + '：'">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledQty') + '：'">
                        <p>{{ form.balprc_qty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledQty') + '：'">
                        <p>{{ form.tran_qty }}</p>
                    </el-form-item>
                    <el-form-item label="应收金额：">
                        <p>{{ form.amt_pay }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.unroundedAmt') + '：'">
                        <p>{{ form.sumamt2 }}</p>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item :label="$t('common.totalWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledWeight') + '：'">
                        <p>{{ form.balqty_wgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledWeight') + '：'">
                        <p>{{ form.tran_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="已收金额：">
                        <p>{{ form.settle_amt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isEdit" @click="refreshData(form.salesj_no)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" size="mini" :disabled="isEdit" @click="saveIt">保存Ctrl-s</el-button>
            </div>
        </div>
        <!-- 弹窗区 -->
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints" style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList"  :key="index">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>

                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" v-if="itemBig.billtype_info" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.billtype_info.billtype_name }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px;">
                                <div>
                                    <div v-if="DataDtl.custno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户编号：{{ itemBig.cust_no }}
                                    </div>
                                    <div v-if="DataDtl.custname.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：{{ itemBig.cust_info.cust_name }}
                                    </div>
                                    <div v-if="DataDtl.counterno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台编号：{{ itemBig.counter_no }}
                                    </div>
                                    <div v-if="DataDtl.countername.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台：{{ itemBig.counter_info.kind_name }}
                                    </div>
                                    <div v-if="DataDtl.billremark.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        备注：{{ itemBig.remark }}
                                    </div>
                                </div>
                                <div>
                                    <div v-if="DataDtl.billno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据编号：{{ itemBig.salesj_no }}
                                    </div>
                                    <div v-if="DataDtl.billdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据日期：{{ itemBig.salesj_date }}
                                    </div>
                                    <div v-if="DataDtl.printdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        打印时间：{{ itemBig.datetime }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.is_fields1 == 1" :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <p class="tableName">
                                <span v-if="DataDtl.table_name1_show == 1">{{ DataDtl.table_name1 }}</span>
                            </p>
                        </div>
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtl_report" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item.style_info[items.no] ? item.style_info[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtl_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>

                    <div v-if="DataDtl.is_fields2 == 1" :style="`margin-bottom:${DataDtl.table2_bottommargin}px;`">
                        <p class="tableName">
                            <span v-if="DataDtl.table_name2_show == 1">{{ DataDtl.table_name2 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields2_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields2">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.bill_report" :key="index">
                                <template v-for="items in fields2">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item.style_info ? item.style_info[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table2_total_show == 1">
                                <template v-for="(items, indexs) in fields2">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.bill_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>

                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="memberBalancePrint" v-if="itemBig.member_id">
                                <div>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">会员总额 {{ itemBig.member_balance_before }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">本次消费 {{ itemBig.member_deduct_amt }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">会员余额 {{ itemBig.member_balance_after }}</span>
                                </div>
                            </div>
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">总计 金额大写 {{ itemBig.money_type }}</span>
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money_chinese }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.money }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div v-if="DataDtl.custaccounts_begin">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_begin.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_begin"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="DataDtl.custaccounts_end">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_end.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_end"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="DataDtl.custaccounts_now">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_now.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_now"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-for="(accountConfig, index) in sortedCustAccounts"
                            :key="index"
                            v-if="accountConfig && accountConfig.is_show == 1"
                            :style="`font-size:${accountConfig.font_size}px;`"
                        >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p style="width: 25%; display: flex; justify-content: space-between"
                                   v-for="(item, itemIndex) in itemBig[accountConfig.dataKey]"
                                   :key="itemIndex"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span v-if="itemBig.build_has">{{ itemBig.build_has.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span v-if="itemBig.salesman_report">{{ itemBig.salesman_report.staffr_name }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: right;">
                        <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                    </div>
                    <div v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">{{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 参数设置弹出框 -->
        <el-dialog
            title="参数设置"
            :visible.sync="moduleParamSetData.isshow"
            width="30%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body>

            <el-form label-width="150px" size="small">
                <div class="param-description">
                    <i class="el-icon-info" style="color: #409EFF;"></i>
                    <span>设置本模块表格内的尾数处理方式。小数位设置请到移步【系统参数】设置</span>
                </div>

                <el-divider></el-divider>

                <el-form-item label="折足重尾数处理：">
                    <el-radio-group v-model="moduleParamSetData.data.transWgtRoundingMode" size="mini">
                        <el-radio :label="0" border>四舍五入</el-radio>
                        <el-radio :label="1" border>直接舍去</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="金额尾数处理：">
                    <el-radio-group v-model="moduleParamSetData.data.amtRoundingMode" size="mini">
                        <el-radio :label="0" border>四舍五入</el-radio>
                        <el-radio :label="1" border>直接舍去</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="金额取整数：">
                    <el-radio-group v-model="moduleParamSetData.data.amtInteger" size="mini">
                        <el-radio :label="0" border>否</el-radio>
                        <el-radio :label="1" border>是</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="moduleParamSetData.isshow = false">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" size="small" @click="editmoduleParamSet">{{ $t('common.confirm') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    salesjQuitIndex,
    salesjQuitPull,
    salesjQuitDel,
    salesjQuitCheck,
    salesjQuitChecks,
    salesjQuitReflex,
    salesjQuitSum,
    salesjQuitAdd,
    salesjQuitUpdate,
    salesjQuitScreen,
    salesjQuitSearch,
    apiGetinfo,
    // salesjGetRandoms,
    apiPrintOutbound,
    salesjBring,
    salesjBringStyle,
    getPrinOut_pull,
    apiCustStyleWage,
    apiCurrentPermisson,
    setScale,
    salesGetBarcodeInfo,
    salesIsAllowUpdate,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiPrintOutboundprintLabel,
    apiGetCutAccount,
    apiGetModuleParamSetData,
    apiGetCustParamSetData,
    apiUpModuleParamSetData
    ,apiGetProcessItemNoData
    ,apiGetDataMemberManage
} from '@/request/api';
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import html2canvas from 'html2canvas';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'outbound',
    data() {
        return {
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            isEdit: true, //是否可编辑
            isCheck: false, //是否审核
            isAdd: false, //是否新增数据
            nullBtn: false, //是否空数据
            first: true, //是否有上一条
            last: true, //是否有下一条
            type: 4, //单据切换，
            form: {}, //全局数据
            pullData: {}, //下拉数据
            checkData: { isshow: false, scope: null, index: 0, data: {} }, //审核
            outData: { isshow: false, scope: null, index: 0, data: {} }, //筛选,
            excelData: { isshow: false, scope: null, index: 0, data: {} }, //导出
            printData: { isshow: false, scope: null, index: 0, data: {} },

            bonusData: [], //筛选选择数据
            arr: [], //筛选一级
            arrs: [], //筛选二级
            searchData: [], //筛选数据返回列表
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            systemSet: {}, //系统配置，
            dtlIndex: '-1', //列表当前位置
            billIndex: '-1',
            amtIndex: '-1',
            //导出参数
            excelValue: '',
            keyword: '',
            cust_no: '',
            salesman_no: '',
            style_no: '',
            bill_mode: '',
            counter_no: '',
            salesj_date_x: '',
            datetime_x: '',
            dtlTransWgtTotal: 0,
            billTotalWgt: 0,
            // Random: '',

            printType: '出库单',
            loading: false,
            printList: {},
            printDtl: [],
            printBill: [],
            dtlTotal: '',
            billToatal: '',
            buildHas: '',
            printCust: '',
            printSale: '',
            printStock: [],
            printStockStart: [],
            printStockend: [],
            maxHeight: 300,
            shouinbound: false,
            isSave: true,
            dtl_amt_pay: 0, //明细金额
            bill_amt_pay: 0, //明细金额
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            zkKeyList: [],
            fkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalZkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalFkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '10',
            perData: {}, //权限
            rowSeq: 0,
            wgtValue: 0,
            reader: null, // 声明为组件属性
            port: null, // 声明为组件属性
            shouldStopReading: false,

            // 批量字段
            batchSelect: '',
            selectRecords: [],
            batchOption: '1',
            flagFalse: false,

            stylePull: null,

            moduleParamSetData: { isshow: false, data: {} },
            transWgtRoundingMode:0,
            amtRoundingMode:0,
            amtInteger:0,
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },

    mounted() {
        this.getPull();
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.searchIt(bill_no);
        } else {
            this.getData();
        }
        this.getPulls();
        this.getTable();
        this.getTable1();
        this.getTable2();
        this.getPermission();
        this.getModuleParamSetData();

        document.addEventListener('keydown', (event) => {
            if (event.key === 'F9') {
                this.getValue();
            } else {
                this.mykeyup(event);
            }
        });

        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
                if (this.originalZkKeyList && this.originalZkKeyList.length > 0) {
                    this.zkKeyList = translateColumns(this.originalZkKeyList, newLang || 'zh-CN');
                }
                if (this.originalFkKeyList && this.originalFkKeyList.length > 0) {
                    this.fkKeyList = translateColumns(this.originalFkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        // 返回一个 Promise，包含关闭串口的异步操作
        const closePromise = this.closeSerial();
        // 等待所有异步操作完成后再销毁组件
        Promise.all([closePromise])
            .then(() => {
                console.log('Serial port closed successfully.');
            })
            .catch((error) => {
                console.error('Error closing serial port:', error);
            });
        next();
    },
    beforeDestroy() {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'F9') {
            }
        });
    },
    methods: {
        // ==================== 会员信息查询 ====================

        // 获取会员信息，并自动填充会员ID/名称等
        // type为cust时按客户编号查询，否则按手机号查询
        getMemberData(type) {
            const data =
                type === 'cust'
                    ? { cust_no: this.form.cust_no, bill_date: this.form.salesj_date }
                    : { phone: this.form.member_phone, bill_date: this.form.salesj_date };
            // 查询条件为空时不发起请求
            if (!data.cust_no && !data.phone) {
                return;
            }
            apiGetDataMemberManage(data).then((res) => {
                if (res.code == 2000 && res.data) {
                    this.$set(this.form, 'member_phone', res.data.phone);
                    this.$set(this.form, 'member_id', res.data.id);
                    this.$set(this.form, 'member_name', res.data.name);
                    this.$set(this.form, 'member_balance', res.data.member_balance || []);
                    // 带出客户
                    this.$set(this.form, 'cust_no', res.data.cust_no);
                } else {
                    this.$set(this.form, 'member_deduct_amt', 0);
                    this.$set(this.form, 'member_phone', '');
                    this.$set(this.form, 'member_id', '');
                    this.$set(this.form, 'member_name', '');
                    this.$set(this.form, 'member_balance', []);
                    this.$message.warning('未查询到该会员信息');
                }
            });
        },
        // 抵扣工费：将货品明细amt列合计赋值给储值抵扣金额，不超过对应币别的会员余额
        deductLaborFee() {
            let dtlData = this.$refs.dtlTable.getTableData().fullData;
            if (!dtlData || dtlData.length === 0) {
                this.$message.warning('货品明细为空，无法抵扣');
                return;
            }
            // 计算货品明细amt合计
            const totalAmt = dtlData.reduce((sum, item) => {
                return sum + (Number(item.amt) || 0);
            }, 0);
            // 获取单据主表币别
            const billCurrency = this.form.currency_no;
            if (!billCurrency) {
                this.$message.warning('请先选择单据币别');
                return;
            }
            // 查找会员余额中对应币别的金额
            const balanceItem = (this.form.member_balance || []).find(b => b.currency_no === billCurrency);
            if (!balanceItem) {
                this.$message.warning('该会员没有当前币别（' + billCurrency + '）的余额');
                return;
            }
            const balanceAmt = Number(balanceItem.amt) || 0;
            // 判断抵扣金额是否超过余额
            if (totalAmt > balanceAmt) {
                this.$message.warning('抵扣金额（' + totalAmt.toFixed(this.systemSet.amt) + '）超过会员余额（' + balanceAmt.toFixed(this.systemSet.amt) + '），已按余额赋值');
                this.$set(this.form, 'member_deduct_amt', balanceAmt.toFixed(this.systemSet.amt));
            } else {
                this.$set(this.form, 'member_deduct_amt', totalAmt.toFixed(this.systemSet.amt));
            }
            this.foottotal();
        },
        //模块内参数设置
        showModuleParamSet(){
            this.getModuleParamSetData();
            this.moduleParamSetData.isshow=true;
        },
        getModuleParamSetData() {
            apiGetModuleParamSetData({
                code_id: '31'
            }).then((res) => {
                if (res.code == 2000) {
                    this.moduleParamSetData.data = res.data;
                    this.transWgtRoundingMode = res.data.transWgtRoundingMode;
                    this.amtRoundingMode = res.data.amtRoundingMode;
                    this.amtInteger = res.data.amtInteger;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getCustParamSetData() {
            apiGetCustParamSetData({
                code_id: '31',
                cust_no: this.form.cust_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.amtRoundingMode = res.data.amtRoundingModeCust;
                    this.amtInteger = res.data.amtIntegerCust;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        editmoduleParamSet() {
            let data = this.moduleParamSetData.data;
            apiUpModuleParamSetData(data).then((res) => {
                if (res.code == 2000) {
                    this.moduleParamSetData.data = res.data;
                    this.transWgtRoundingMode = res.data.transWgtRoundingMode;
                    this.amtRoundingMode = res.data.amtRoundingMode;
                    this.amtInteger = res.data.amtInteger;
                    this.moduleParamSetData.isshow=false;
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        fetchCustAccount(custNo, endDate) {
            const data = {
                custNo: custNo,
                endDate: endDate
            };
            apiGetCutAccount(data).then(res => {
                if (res.code === 2000) {
                    this.form.custAccount = res.data;
                    this.$refs.custAccountTable.loadData(res.data);
                }
            });
        },
        billDateChange(v) {
            this.fetchCustAccount(this.form.cust_no, v);
            this.getMemberData();
        },
        selectCustChange(v) {
            this.fetchCustAccount(v, this.form.salesj_date);
        },
        setStylePulls() {
            let counterNo = this.form.counter_no;
            if (!this.stylePull || !Array.isArray(this.stylePull)) {
                return;
            }
            this.pullData.style = JSON.parse(JSON.stringify(this.stylePull));
            if (counterNo) {
                // 筛选出 counter_no 等于 $counterNo 或者 counter_no 为空或 null 的项
                // this.pullData.style = this.stylePull.filter(item =>
                //     item.counter_no === counterNo ||
                //     item.counter_no === '' ||
                //     item.counter_no === null ||
                //     item.counter_no === undefined
                // );
                // 将 counter_no 不等于 $counterNo 且不为空/NULL 并且 status 为1 的项的 status 值设为 0
                this.pullData.style.forEach(item => {
                    if ((item.counter_no === counterNo ||
                            item.counter_no === '' ||
                            item.counter_no === null ||
                            item.counter_no === undefined) &&
                        item.status === 1) {
                        item.status = 1;
                    } else {
                        item.status = 0;
                    }
                });
                // 按status倒序，按style_no正序进行排序
                this.pullData.style.sort((a, b) => {
                    if (a.status !== b.status) {
                        return b.status - a.status; // status 倒序
                    }
                    return a.style_no.localeCompare(b.style_no); // style_no 正序
                });
            }
        },
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r) {
            // console.log(e, r, 'er');
            if (e.value) {
                var table1 = this.$refs.dtlTable.getTableData().fullData;
                if (this.batchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.batchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    this.calculationDtl(table1[i]);
                }
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        closingCopy(){
            if(this.selectRecords.length == 0){
                this.$message.error('请选择要复制的行');
                return;
            }
            if (this.selectRecords.length > 1) {
                this.$message.error('仅可选择一行复制');
                return;
            } else {
                const filteredRecords = this.selectRecords.map((record) => {
                    const { barcode, ...rest } = record;
                    return rest;
                });
                this.$refs.dtlTable.insertAt(filteredRecords, -1);
            }
        },
        stopReading() {
            // 设置一个标志来指示循环是否应该停止
            this.shouldStopReading = true;
        },
        async serial() {
            if ('serial' in navigator) {
                // 重置停止读取的标志
                this.shouldStopReading = false;

                this.port = await navigator.serial.requestPort();
                await this.port.open({ baudRate: 9600 });

                const decoder = new TextDecoderStream();
                this.port.readable.pipeTo(decoder.writable);
                const inputStream = decoder.readable.pipeThrough(new TransformStream(new LineBreakTransformer()));
                this.reader = inputStream.getReader();

                try {
                    while (true) {
                        const { value, done } = await this.reader.read();
                        if (done || this.shouldStopReading) {
                            // 检查停止读取的标志
                            break;
                        }
                        var wgt = value;
                        var numberStr = wgt.replace(/[^0-9.]/g, '');
                        this.wgtValue = parseFloat(numberStr);

                        console.log('this.wgtValue:', this.wgtValue);
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    this.reader.releaseLock();
                    await this.port.close();
                }
            }
        },
        async closeSerial() {
            try {
                // 停止数据读取循环
                this.stopReading();

                if (this.reader) {
                    await this.reader.cancel(); // 取消读取器
                    this.reader.releaseLock(); // 释放读取器锁定
                    this.reader = null; // 清空读取器
                }
                if (this.port) {
                    const writer = this.port.writable.getWriter();
                    await writer.close(); // 关闭写入器
                    this.port.close(); // 关闭串口
                    this.port = null; // 清空串口
                }
            } catch (error) {
                console.error('Error closing serial port:', error);
            }
        },
        getValue() {
            // console.log(this.wgtValue, '?');
            if ((this.isAdd && this.rowSeq != 0 && this.reader != null) || (!this.isEdit && this.rowSeq != 0 && this.reader != null)) {
                var table1 = this.$refs.dtlTable.getTableData().fullData;
                // console.log(table1, this.rowSeq, 'ddd!');
                table1[--this.rowSeq].wgt = this.wgtValue;
                if (this.rowSeq >= table1.length) {
                } else {
                    this.$refs.dtlTable.setActiveCell(this.$refs.dtlTable.getTableData().fullData[++this.rowSeq], 'wgt');
                }
                // document.getElementById('bInput').value = this.wgtValue;
            }
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '31'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isEdit) {
                    if (this.$route.path == '/outbound') {
                    }
                    this.saveIt();
                    e.preventDefault();
                    e.returnValue = false;
                }
            }
        },
        //获取数据
        getData() {
            this.$load.show();
            this.setStylePulls();
            salesjQuitIndex({
                type: this.type,
                salesj_no: this.form.salesj_no
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.nullBtn = false;
                    this.form = res.data;
                    this.first = res.ag.first;
                    this.last = res.ag.last;

                    this.maxHeight = 300;
                    if (res.data.dtl.length > 4) {
                        let length = res.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                    if (res.data.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                    this.getCustParamSetData();
                } else {
                    this.$message.error(res.data.info);

                    if (res.data.info == '暂无数据') {
                        this.form = { dtl: [], bill: [], amt: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                }
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        barcodeJump(e, row, type) {
            const v = e.target.value.trim(); // 去除空格
            if (v) {
                if (e.keyCode == '13' || e.keyCode == '9' || e.keyCode == '39') {
                    // 阻止默认行为
                    e.preventDefault();
                    // 所有行数据
                    var rows = this.$refs.dtlTable.getTableData().fullData;
                    // 根据当前行获取行下标
                    var rowIndex = this.$refs.dtlTable.getVTRowIndex(row);
                    let backRow = this.$refs.dtlTable.getTableData().tableData[row.seq - 1];
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode == row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (!allowBreak) {
                        setTimeout(() => {
                            this.$refs.dtlTable.setActiveCell(backRow, 'barcode');
                        }, 300);
                        return;
                    }
                    let data = {
                        barcode: e.target.value.trim(),
                        counter_no: this.form.counter_no,
                        cust_no: this.form.cust_no
                    };
                    salesGetBarcodeInfo(data).then((res) => {
                        if (res.code === 2000) {
                            for (var item in res.data) {
                                row[item] = res.data[item];
                            }
                            // row.wgt_prc = res.data.wgt_prc;
                            // row.style_no = res.data.style_no;
                            // row.qty = res.data.qty;
                            // row.wgt = res.data.wgt;
                            // row.alloy = res.data.alloy;
                            // row.qty_prc = res.data.qty_prc;
                            // row.add_wage = res.data.add_wage;
                            // row.add_qtywage = res.data.add_qtywage;
                            // row.add_wgtwage = res.data.add_wgtwage;
                            // row.barcode = res.data.barcode;
                            //最后一列换行
                            if (rowIndex + 1 == rows.length) {
                                // 最后一行 先增加行在换行
                                this.adddtl();
                                // 换行
                                setTimeout(() => {
                                    let rowDatas = this.$refs.dtlTable.getTableData().fullData;
                                    this.$refs.dtlTable.setActiveRow(rowDatas[rowIndex + 1]);
                                }, 100);
                            } else {
                                this.$refs.dtlTable.setActiveRow(rows[rowIndex + 1]);
                            }
                        } else {
                            row.barcode = '';
                            this.$refs.dtlTable.setActiveCell(backRow, 'barcode');
                            this.$message.error(res.data.info);
                        }
                    });
                }
            }
        },
        // 获取下拉框信息---------------------------------------
        getPull() {
            salesjQuitPull({}).then((res) => {
                this.pullData = res.data;
                this.stylePull = this.pullData.style;
            });
        },
        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '10'
            }).then((res) => {
                this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable1() {
            apiGetListCorrespondingData({
                id: '11'
            }).then((res) => {
                // this.zkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalZkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.zkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable2() {
            apiGetListCorrespondingData({
                id: '12'
            }).then((res) => {
                // this.fkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalFkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.fkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '10';
            } else if (type == 2) {
                this.keyList = this.zkKeyList.map((item) => item);
                this.keyStatus = '11';
            } else if (type == 3) {
                this.keyList = this.fkKeyList.map((item) => item);
                this.keyStatus = '12';
            }
            this.drawers = true;
        },

        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getTable();
            this.getTable1();
            this.getTable2();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 切换单据
        changeOrder(type) {
            this.type = type;
            this.getData();
        },

        /**
         * 对数值进行舍入处理
         * @param {number} value - 需要处理的数值
         * @param {number} decimalPlaces - 保留的小数位数
         * @param {number} roundingMode - 舍入模式：0表示四舍五入，1表示直接舍去
         * @returns {number} 处理后的数值（字符串格式）
         */
        roundValue(value, decimalPlaces, roundingMode, type = '') {
            if (type == 'amt' && this.amtInteger == 1) {
                decimalPlaces = 0;
            }
            if (roundingMode === 1) {
                // 直接舍去尾数（截断）
                const factor = Math.pow(10, decimalPlaces);
                // 先格式化为固定小数位数再转换为数字，避免浮点精度问题
                const multiplied = Number((value * factor).toFixed(10));
                const truncated = Math.trunc(multiplied);
                const result = truncated / factor;
                return result.toFixed(decimalPlaces);
            } else {
                // 四舍五入
                return Number(value).toFixed(decimalPlaces);
            }
        },
        // 表格行计算
        calculationDtl(row){
            //折足重
            if (row.unit_wgt && Number(row.unit_wgt) !== 0) {
                let wgt = this.$utils.multiply(Number(row.qty || 0), Number(row.unit_wgt || 0));
                row.wgt = Number(wgt).toFixed(this.systemSet.wgt);
            }
            //含耗重
            let containloss_wgt = this.$utils.multiply(Number(row.wgt || 0), Number(row.containloss_rate || 1));
            row.containloss_wgt = Number(containloss_wgt).toFixed(this.systemSet.wgt);

            let trans_wgt = this.$utils.multiply((Number(row.containloss_wgt || 0) - Number(row.loss_wgt || 0)), Number(row.alloy || 1));
            // let trans_wgt = this.$utils.multiply((Number(row.wgt || 0) - Number(row.loss_wgt || 0)), Number(row.alloy || 1));
            // row.trans_wgt = Number(trans_wgt).toFixed(this.systemSet.wgt);
            row.trans_wgt = this.roundValue(trans_wgt, this.systemSet.wgt, this.transWgtRoundingMode);

            //手续费
            let commission_amt =
                Number(row.qty || 0) * Number(row.commission_qty_prc || 0) +
                Number(row.wgt || 0) * Number(row.commission_wgt_prc || 0) +
                Number(row.commission_add_amt || 0);
            // row.commission_amt = Number(commission_amt).toFixed(this.systemSet.amt);
            row.commission_amt = this.roundValue(commission_amt, this.systemSet.amt, this.amtRoundingMode, 'amt');

            //工费金额
            let wage_amt =
                (Number(row.qty || 0) * Number(row.qty_prc || 0) * Number(row.qty_prc_multiplier || 0) +
                    Number(row.qty || 0) * Number(row.add_qtywage || 0) +
                    Number(row.wgt || 0) * Number(row.wgt_prc || 0) +
                    Number(row.wgt || 0) * Number(row.add_wgtwage || 0) +
                    Number(row.trans_wgt || 0) * Number(row.trans_wgt_prc || 0) +
                    Number(row.add_wage || 0) +
                    Number(row.goods_wgt || 0) * Number(row.goods_wgt_prc || 0) +
                    Number(row.goods_wgt || 0) * Number(row.goods_wgt_prc2 || 0) +
                    Number(row.qty || 0) * Number(row.qty_prc1 || 0) +
                    Number(row.qty || 0) * Number(row.qty_prc2 || 0) +
                    Number(row.qty || 0) * Number(row.qty_prc3 || 0) +
                    Number(row.wgt || 0) * Number(row.wgt_prc1 || 0) +
                    Number(row.wgt || 0) * Number(row.wgt_prc2 || 0) +
                    Number(row.wgt || 0) * Number(row.wgt_prc3 || 0) +
                    Number(row.containloss_wgt || 0) * Number(row.containloss_wgt_prc || 0))
                * Number(row.discount || 1);
            // row.wage_amt = Number(wage_amt).toFixed(this.systemSet.amt);
            row.wage_amt = this.roundValue(wage_amt, this.systemSet.amt, this.amtRoundingMode, 'amt');

            //原金额
            let original_amt =
                Number(row.qty || 0) * Number(row.qty_prc || 0) +
                Number(row.qty || 0) * Number(row.add_qtywage || 0) +
                Number(row.wgt || 0) * Number(row.wgt_prc || 0) +
                Number(row.wgt || 0) * Number(row.add_wgtwage || 0) +
                Number(row.trans_wgt || 0) * Number(row.trans_wgt_prc || 0) +
                Number(row.add_wage || 0) +
                Number(row.goods_wgt || 0) * Number(row.goods_wgt_prc || 0) +
                Number(row.goods_wgt || 0) * Number(row.goods_wgt_prc2 || 0) +
                Number(row.qty || 0) * Number(row.qty_prc1 || 0) +
                Number(row.qty || 0) * Number(row.qty_prc2 || 0) +
                Number(row.qty || 0) * Number(row.qty_prc3 || 0) +
                Number(row.wgt || 0) * Number(row.wgt_prc1 || 0) +
                Number(row.wgt || 0) * Number(row.wgt_prc2 || 0) +
                Number(row.wgt || 0) * Number(row.wgt_prc3 || 0) +

                Number(row.qty || 0) * Number(row.commission_qty_prc || 0) +
                Number(row.wgt || 0) * Number(row.commission_wgt_prc || 0) +
                Number(row.containloss_wgt || 0) * Number(row.containloss_wgt_prc || 0) +
                Number(row.commission_add_amt || 0);
            // row.original_amt = Number(original_amt).toFixed(this.systemSet.amt);
            row.original_amt = this.roundValue(original_amt, this.systemSet.amt, this.amtRoundingMode, 'amt');

            //金额
            let amt = Number(row.wage_amt || 0) + Number(row.commission_amt || 0);
            // row.amt = Number(amt).toFixed(this.systemSet.amt);
            row.amt = this.roundValue(amt, this.systemSet.amt, this.amtRoundingMode, 'amt');
        },
        calculationBill(row){
            //折足重
            let trans_wgt = this.$utils.multiply(Number(row.wgt || 0), Number(row.alloy || 1));
            // row.trans_wgt = Number(trans_wgt).toFixed(this.systemSet.wgt);
            row.trans_wgt = this.roundValue(trans_wgt, this.systemSet.wgt, this.transWgtRoundingMode);

            //原金额
            let original_amt =
                Number(row.qty || 0) * Number(row.qty_prc || 0) +
                Number(row.trans_wgt || 0) * Number(row.wgt_prc || 0);

            // row.original_amt = Number(original_amt).toFixed(this.systemSet.amt);
            row.original_amt = this.roundValue(original_amt, this.systemSet.amt, this.amtRoundingMode, 'amt');

            //抹零金额（手动输入金额算出抹零金额）
            let rawRoundoffAmt = 0;
            if (row.manual_amt && Number(row.manual_amt) !== 0) {
                rawRoundoffAmt = Number(row.manual_amt || 0) - (Number(row.wgt || 0) * Number(row.wgt_prc || 0));
            }
            row.roundoff_amt = Number(rawRoundoffAmt).toFixed(this.systemSet.amt);

            //金额
            let amt = Number(row.original_amt || 0) * Number(row.discount || 1) + Number(row.roundoff_amt || 0);
            // row.amt = Number(amt).toFixed(this.systemSet.amt);
            row.amt = this.roundValue(amt, this.systemSet.amt, this.amtRoundingMode, 'amt');

        },
        // 行样式方法
        rowStyleMethod({ row }) {
            if (row.type === '实时') {
                return { background: '#fff7e6' } // 浅黄色 - 期初
            } else if (row.type === '本期') {
                return { background: '#e6f7ff' } // 浅蓝色 - 本期
            } else if (row.type === '期末') {
                return { background: '#f6ffed' } // 浅绿色 - 期末
            }
            return {}
        },
        // 不可编辑-------------------------------------
        activeRowMethod(row) {
            if (row.seq) {
                this.rowSeq = row.seq;
                //console.log(this.rowSeq, 'this.rowSeq');
            } else {
                ++this.rowSeq;
            }
            if (this.isEdit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        checkRadioMethod() {
            return false;
        },
        //编辑
        edit() {
            salesIsAllowUpdate({ salesj_no: this.form.salesj_no }).then((res) => {
                if (res.code === 2000) {
                    this.isEdit = false;
                    this.isAdd = false;
                    this.getInbound();
                    if (this.form.amt.length == 0) {
                        this.insertEvent2(-1);
                    }
                    if (this.form.dtl.length == 0) {
                        this.insertEvent(-1);
                    }
                    if (this.form.bill.length == 0) {
                        this.insertEvent1(-1);
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 新建
        add() {
            // this.getRandom();
            this.isEdit = false;
            this.isAdd = true;
            this.isSave = true;
            this.form = { salesj_date: '' };
            this.form.salesj_date = this.$getTime();
            const keys = Object.keys(this.pullData);
            const formKeys = keys.map((key) => `${key}_no`);
            keys.forEach((key, index) => {
                if (Array.isArray(this.pullData[key])) {
                    // 确保 this.pullData[key] 是一个数组，而不是 undefined 或 null
                    const defaultItem = this.pullData[key].find((item) => item.isdefault == 1);
                    if (defaultItem) {
                        // 确保 defaultItem 和属性 formKeys[index] 存在
                        if (defaultItem.hasOwnProperty(formKeys[index])) {
                            this.form[formKeys[index]] = defaultItem[formKeys[index]];
                        } else {
                            console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                            this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                        }
                    } else {
                        // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                        console.warn(`No defaultItem found for key ${key}`);
                        this.form[formKeys[index]] = '';
                    }
                } else {
                    // 如果 this.pullData[key] 不是一个数组，输出警告
                    console.warn(`Expected an array for key ${key}, but found ${typeof this.pullData[key]}`);
                }
            });
            this.setStylePulls();
            this.maxHeight = 300;
            setTimeout(() => {
                for (let i = 0; i < 3; i++) {
                    this.insertEvent(-1);
                    this.insertEvent1(-1);
                    this.insertEvent2(-1);
                }
            }, 100);
        },
        // getRandom() {
        //     this.Random = '';
        //     salesjGetRandoms().then((res) => {
        //         this.Random = res.data;
        //     });
        // },
        //删除
        deleteIt() {
            salesIsAllowUpdate({ salesj_no: this.form.salesj_no }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除该出库单吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        salesjQuitDel({ salesj_no: this.form.salesj_no }).then((res) => {
                            if (res.code == 2000) {
                                this.$message.success('删除成功');

                                if (this.last) {
                                    this.type = 4;
                                }
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回
        refreshData(id) {
            this.isEdit = true;
            this.selectRecords = [];
            this.type = 4;
            if (id) {
                this.searchIt(id);
            } else {
                this.getData();
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/outbound');
            }
        },
        // 保存
        saveIt() {
            const billArray = Array.isArray(this.form.bill) ? this.form.bill : [];

            // 检查是否存在结价金额为0的记录
            const hasInvalidBillItems = billArray.some(
                // item => item.bill_mode_no === 'BALPRC' && item.style_no && (!item.amt || item.amt == 0)
                item => {
                    // 查找 pullData.bill_mode 中 bill_mode_no 相同且 mode 为 0 的项
                    const billModes = this.pullData.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && mode.mode === 0
                    );
                    return matchingBillMode && item.style_no && (!item.amt || item.amt == 0);
                }
            );

            // 检查是否存在结料且金额不为0的记录
            const hasInvalidTranItems = billArray.some(
                // item => item.bill_mode_no === 'TRAN' && item.style_no && item.amt && item.amt != 0
                item => {
                    // 查找 pullData.bill_mode 中 bill_mode_no 相同且 mode 为 1 或 -1 的项
                    const billModes = this.pullData.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && (mode.mode === 1 || mode.mode === -1)
                    );
                    return matchingBillMode && item.style_no && item.amt && item.amt != 0;
                }
            );

            if (hasInvalidBillItems) {
                this.$confirm('账款明细存在结价金额为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {});
            } else if (hasInvalidTranItems) {
                this.$confirm('账款明细存在结料且金额不为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {});
            } else {
                this.proceedToSave();
            }
        },
        proceedToSave() {
            // 检查重量合计数是否一致
            const isWeightMismatch = Number(this.dtlTransWgtTotal) !== Number(this.billTotalWgt);
            // 如果重量不一致，则弹出确认框
            if (isWeightMismatch) {
                this.$confirm('账款明细重量与货品明细重量不一致，是否保存？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.getSave();
                }).catch(() => {
                });
            } else {
                this.getSave();
            }
        },
        getSave() {
            if (this.isSave) {
                this.isSave = false;
                this.$load.show();
                let data = this.$deepClone(this.form);
                let dtl = this.$refs.dtlTable.getTableData().fullData;
                data.dtl = dtl;
                data.bill = this.$refs.billTable.getTableData().fullData;
                data.amt = this.$refs.amtTable.getTableData().fullData;
                data.no = this.$refs.orderTable.getCheckboxRecords();
                if (this.isAdd) {
                    // data.random = this.Random;
                    salesjQuitAdd({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功');
                            this.type = 4;
                            this.isEdit = true;
                            this.isAdd = true;
                            this.getData();
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/outbound');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    salesjQuitUpdate({ ...data }).then((res) => {
                        this.$load.close();
                        if (res.code == 2000) {
                            this.isEdit = true;
                            this.isAdd = true;
                            this.$message.success('修改成功');
                            // this.getData();
                            this.searchIt(this.form.salesj_no);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                    });
                }
                this.selectRecords = [];
            }
        },
        // 打印
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        // 打印
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintOutbound({
                salesj_no: this.form.salesj_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintOutbound({
                salesj_no: this.form.salesj_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.printList = res.data.dtl;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    // this.$message.error(res.data.info);
                    this.printOut();
                }
            });
        },
        // 标签打印
        labelClick() {
            apiPrintOutboundprintLabel({ salesj_no: this.form.salesj_no }).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS(
                //   {
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                //   }
                // )
                //
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile(this.printType + '.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        // 导出
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //导出excel----------------------------------------
        outExcel() {
            var name = this.username;
            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'salesj_export', {
                    params: {
                        login_staff: name,
                        salesj_no: this.keyword,
                        type: this.excelValue,
                        cust_no: this.cust_no,
                        style_no: this.style_no,
                        salesman_no: this.salesman_no,
                        counter_no: this.counter_no,
                        bill_mode: this.bill_mode,
                        salesj_date: this.salesj_date_x,
                        datetime: this.datetime_x
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(this.$baseURL + 'salesj_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: this.excelValue
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '模板.xlsx';
                    link.click();
                });
        },
        // 审核
        check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            salesjQuitCheck({
                salesj_no: this.form.salesj_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.searchIt(this.form.salesj_no);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        // 结价转欠
        closingPrice(type) {
            let dtl = JSON.stringify(this.$refs.dtlTable.getTableData().fullData);
            salesjQuitReflex({
                type,
                dtl
            }).then((res) => {
                this.form.bill = res.data.bill;
                this.form.sumqty = res.data.all.sum;
                this.form.balprc_qty = res.data.all.jie_sum;
                this.form.sumwgt = res.data.all.wgt;
                this.form.balqty_wgt = res.data.all.jie_wgt;
                // this.form.settle_amt = res.data.all.pay_fu;
                this.form.amt_pay = this.$formatOrderAmt(Number(res.data.all.amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0), this.systemSet.zero_deal, this.systemSet.amt);
                this.form.sumamt2 = (Number(res.data.all.amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0)).toFixed(this.systemSet.amt);
                this.form.tran_wgt = res.data.all.liao_wgt;
                this.form.tran_qty = res.data.all.liao_sum;
                this.$forceUpdate();
                setTimeout(() => {
                    const $table = this.$refs.billTable;
                    $table.updateFooter();
                }, 100);
            });
        },
        foottotal() {
            let member_deduct_amt = (this.form.member_deduct_amt || 0);
            let dtl = this.$refs.dtlTable.getTableData().fullData;
            let bill = this.$refs.billTable.getTableData().fullData;
            let amt = this.$refs.amtTable.getTableData().fullData;
            salesjQuitSum({ dtl, bill, amt, member_deduct_amt }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sumtrans_wgt = res.data.sumtrans_wgt;
                this.form.settle_amt = res.data.settle_amt;
                this.form.tran_qty = res.data.tran_qty;
                this.form.tran_wgt = res.data.tran_wgt;
                this.form.balprc_qty = res.data.balprc_qty;
                this.form.balqty_wgt = res.data.balprc_wgt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },
        // 筛选功能--------------------------------------------------
        showInput() {
            let item = { field: '', condition: '', parameter: '' };
            this.bonusData.push(item);
        },
        selectOne(val) {
            //二级条件
            let arr = this.pullData.screen_pull.filter((item) => {
                return item.table == val;
            });
            this.arr = arr[0].field;
        },
        selectOne1(val) {
            // 三级数据
            let arrs = this.pullData.screen_pull[0].field.filter((item) => item.name_no == val);
            this.arrs = arrs[0].select;
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        // 确认筛选-------------------------------------------------
        saveOk() {
            let data = JSON.stringify(this.bonusData);
            this.$load.show();
            salesjQuitScreen({
                data,
                page: this.pageIndex,
                page_size: this.pageSize
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.searchData = res.data.data || [];
                    this.pageTotal = res.data.count;
                } else {
                }
            });
        },
        searchIt(id) {
            this.isEdit = true;
            this.$load.show();
            salesjQuitSearch({
                salesj_no: id
            }).then((res) => {
                this.outData.isshow = false;
                this.$load.close();
                if (res.code == 2000) {
                    this.first = res.ag.first;
                    this.last = res.ag.last;
                    this.form = res.data;
                    this.maxHeight = 300;
                    if (res.data.dtl.length > 4) {
                        let length = res.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                    if (res.data.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                    this.setStylePulls();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取引用用数据
        selectCust(value) {
            if (value) {
                let item = this.pullData.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
                this.getCustParamSetData();
            }
            this.getInbound();
            if (this.systemSet.isMember == 1) {
                this.getMemberData('cust');
            }
        },
        changeCounter(value) {
            this.getInbound();
            this.setStylePulls();
        },
        getInbound() {
            salesjBring({
                cust_no: this.form.cust_no,
                counter_no: this.form.counter_no,
                salesj_no: this.form.salesj_no
            }).then((res) => {
                this.form.bring = res.data;
                res.data.forEach((item) => {
                    if (item.mo == 1) {
                        this.$refs.orderTable.setCheckboxRow(item, true);
                    }
                });
                this.$forceUpdate();
            });
        },
        // 修改成品附加数据
        changeData(row, type, e) {
            //
            // if (Object.keys(this.pullData).length > 0) {
            //     if (style_no) {
            //         let bill = this.pullData.style.filter(item => item.style_no == style_no);
            //
            //         (row.type_no = bill[0].type_no), (row.gold_no = bill[0].gold_no);
            //     }
            // }

            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.pullData[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`pullData[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }

            if (e == 'dtl') {
                if (type + '_no' == 'style_no') {
                    apiCustStyleWage({ cust_no: this.form.cust_no, style_no: selectedNo, type: 'out' }).then((res) => {
                        if (res.code == 2000) {
                            for (var item in res.data) {
                                row[item] = res.data[item];
                            }
                            this.calculationDtl(row);
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                }
            }
        },
        // 获取货号数据
        getItemNoData(e,row) {
            if (e.keyCode == '13' || e.keyCode == '9' || e.keyCode == '39') {
                apiGetProcessItemNoData({ no: row['itemno'], type: 'itemno' }).then((res) => {
                    if (res.code == 2000) {
                        for (var item in res.data.data) {
                            row[item] = res.data.data[item];
                        }
                        // 跳转到下一列
                        var rows = this.$refs.dtlTable.getTableData().fullData;
                        var rowIndex = this.$refs.dtlTable.getVTRowIndex(row);
                        if (rowIndex + 1 == rows.length) {
                            // 最后一行 先增加行在换行
                            this.adddtl();
                            // 换行
                            setTimeout(() => {
                                let rowDatas = this.$refs.dtlTable.getTableData().fullData;
                                this.$refs.dtlTable.setActiveRow(rowDatas[rowIndex + 1]);
                            }, 100);
                        } else {
                            this.$refs.dtlTable.setActiveRow(rows[rowIndex + 1]);
                        }
                    } else {
                        this.$message.error(res.data.info);
                        row['itemno']='';
                    }
                });
            }
        },
        // 新增货品明细
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.dtlTable.getTableData().fullData.length;
            if (length > 4 && length < 11) {
                this.maxHeight += 48;
            }
        },
        deldtl(scoped) {
            let length = this.$refs.dtlTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.dtlTable.remove(scoped.row);
            if (length > 4 && length < 10) {
                this.maxHeight -= 48;
            }
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isEdit) {
                this.dtlIndex = row.seq;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增账款明细
        addbill() {
            this.insertEvent1(-1);
        },
        delbill(scoped) {
            let length = this.$refs.billTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.billTable.remove(scoped.row);
        },
        billenter(row) {
            if (!this.isEdit) {
                this.billIndex = row.seq;
            }
        },
        billleave() {
            this.billIndex = '-1';
        },
        // 新增付款明细
        addamt() {
            this.insertEvent2(-1);
        },
        delamt(scoped) {
            let length = this.$refs.amtTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.amtTable.remove(scoped.row);
        },
        amtenter(row) {
            if (!this.isEdit) {
                this.amtIndex = row.$rowIndex;
            }
        },
        amtleave() {
            this.amtIndex = '-1';
        },
        //tbale增加条数
        async insertEvent(row) {
            let record = {
                gold_no: '',
                type_no: '',
                containloss_rate: 1,
                alloy: 1,
                qty_prc_multiplier: 1,
                discount: 1
            };
            let { row: newRow } = await this.$refs.dtlTable.insertAt(record, row);
            await this.$refs.dtlTable.setActiveCell(newRow, 'seq');
        },
        //tbale增加条数
        async insertEvent1(row) {
            let record = {
                discount: 1,
                alloy: 1
            };
            let { row: newRow } = await this.$refs.billTable.insertAt(record, row);
            await this.$refs.dtlTable.setActiveCell(newRow, 'seq');
        },
        async insertEvent2(row) {
            let record = {
                currency_no: this.systemSet.currency_no
            };
            let { row: newRow } = await this.$refs.amtTable.insertAt(record, row);
            await this.$refs.dtlTable.setActiveCell(newRow, 'seq');
        },
        sumNum(list, field) {
            let count = 0;
            list.forEach((item) => {
                count += Number(item[field]);
            });
            return count;
        },
        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.form.sumwgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        // 判断 data 中是否存在 trans_wgt 字段
                        const hasTransWgt = data.some(item => item.hasOwnProperty('trans_wgt'));
                        if (hasTransWgt) {
                            // 如果存在 trans_wgt，则计算 trans_wgt 的合计
                            this.dtlTransWgtTotal = `${this.$utils.sum(data, 'trans_wgt').toFixed(this.systemSet.wgt)}`;
                        } else {
                            // 如果不存在 trans_wgt，则使用 wgt 的合计
                            this.dtlTransWgtTotal = `${this.$utils.sum(data, 'wgt').toFixed(this.systemSet.wgt)}`;
                        }
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'qty') {
                        this.form.sumqty = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'gross_wgt') {
                        this.form.sumgoods_wgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'amt') {
                        this.dtl_amt_pay = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.form.amt_pay = this.$formatOrderAmt(Number(this.bill_amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0), this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = (Number(this.bill_amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0)).toFixed(this.systemSet.amt);
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'original_amt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'trans_wgt') {
                        this.dtlTransWgtTotal = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        // 表尾合计---------------------------------
        footerMethod1({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.billTotalWgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'qty') {
                        this.form.sumqty = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'original_amt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'amt') {
                        this.bill_amt_pay = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.form.amt_pay = this.$formatOrderAmt(Number(this.bill_amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0), this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = (Number(this.bill_amt_pay) + Number(this.dtl_amt_pay) - Number(this.form.member_deduct_amt || 0)).toFixed(this.systemSet.amt);
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'trans_wgt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        footerMethod2({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        this.form.settle_amt = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        //历史单据
        goHistory() {
            this.$router.push({ path: '/outboundHistory', query: { page: 'outbound' } });
        },
        editClosedEvent(row) {
            this.calculationBill(row.row);
            this.foottotal();
        },
        // 引用单据确认
        sureInbound() {
            let dtl = this.$refs.orderTable.getCheckboxRecords();

            salesjBringStyle({
                dtl: JSON.stringify(dtl),
                cust_no: this.form.cust_no
            }).then((res) => {
                this.form.dtl = res.data;
                this.$forceUpdate();
            });
        },
        //分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.saveOk();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.saveOk();
        },
        myfocus() {},
        editClosedEvents() {},
        //    获取重量电子秤数据
        getSetScale(row, type) {
            setScale({
                random: 'BF-202212020941'
            }).then((res) => {
                row[type] = res.data;
            });
        },
        handleBlur(row, field, type, tableRef, tofixed) {
            if (type == 'number') {
                this.$vaildator.all(row, tofixed, field);
            }
            if (tableRef == 'dtlTable') {
                this.calculationDtl(row);
            }
            if (tableRef == 'billTable') {
                this.calculationBill(row);
            }
        },
        handleInput(row, field, type, tableRef) {
            if (tableRef == 'dtlTable') {
                this.calculationDtl(row);
            }
            if (tableRef == 'billTable') {
                this.calculationBill(row);
            }
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type, tableRef) {
            //所有列数据
            let column = this.$refs.dtlTable.getTableColumn().tableColumn;

            // 所有行数据
            var rows = this.$refs.dtlTable.getTableData().tableData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.dtlTable.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.dtlTable.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.dtlTable.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;

            //电子称重量获取
            // if (type == 'wgt') {
            if (e.keyCode == 113) {
                if (type != 'gold_no' && type != 'style_no') {
                    this.getSetScale(row, type);
                }
            }
            // }

            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }

            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.dtlTable.getTableData().tableData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.dtlTable.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.dtlTable.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    // 跳转到下一列
                    this.$refs.dtlTable.setActiveCell(row, downtype);
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.dtlTable.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.dtlTable.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.dtlTable.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.dtlTable.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
// 添加一个 LineBreakTransformer 类
class LineBreakTransformer {
    constructor() {
        this.chunks = '';
    }

    transform(chunk, controller) {
        this.chunks += chunk;
        const lines = this.chunks.split('\r\n');
        this.chunks = lines.pop();
        lines.forEach((line) => controller.enqueue(line));
    }

    flush(controller) {
        controller.enqueue(this.chunks);
    }
}
</script>

<style scoped lang="scss">
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}
.add_ {
    font-size: 20px;

    i {
        margin: 0 2px;
        cursor: pointer;
    }
}

.warpper {
    padding-bottom: 88px;
}
.top {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 0;

    .top_operate {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .top_col {
        font-size: 14px;
        color: #666;
        margin: 10px 0;
        padding: 0 10px;
        box-sizing: border-box;

        span {
            color: #00a2ff;
        }
    }
}
.top_cols {
    background-color: #fff;
    padding: 15px;
    padding-top: 0;
    box-sizing: border-box;
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }
}

.table_warpper {
    display: flex;

    .table2 {
        width: 55%;
        margin-right: 5px;
    }

    .table3 {
        width: 25%;
        margin-right: 5px;
    }

    .table4 {
        width: 20%;
    }
}

.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 40px;
    box-sizing: border-box;
    div {
        display: flex;
        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.checkboxPro1 input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}

.checkboxPro1 input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}

.checkboxPro1 input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
/deep/ .footclass {
    color: red;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
// 答应样式
.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}

.printBox table td,
.printBox table th {
    border: 1px solid #000;
    font-size: 12px;
}

.printBox table th {
    font-weight: bold;
    color: #000;
}

.company {
    font-size: 13px;
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.printTitle {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    letter-spacing: 5px;
}

.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: none;
}

.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.printTop div p {
    line-height: 1.25;
}

.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.summoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px 0 5px;
}

.summoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.summoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.memberBalancePrint {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px 0 5px;
}

.memberBalancePrint span + span {
    margin-left: 20px;
}
.insummoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15% 5px 0;
    border-bottom: 1px solid #000;
}

.insummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.insummoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}

.sum2 {
    border-bottom: 1px solid rgb(7, 16, 114);
    padding: 1px 0;
    display: flex;
    align-items: flex-start;
}

.sum2 p {
    color: #000;
    font-weight: normal;
    border-right: 1px solid #000;
    padding: 0 5px;
}

.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: 5px 0;
}

.sumBotn p span {
    font-size: 14px;
    color: #000;
}

.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}

.img {
    padding-right: 5px;
}
/deep/.vxe-footer--row {
    font-weight: 600;
}

// 出库引用
.inbound {
    width: 100%;
    margin-top: 10px;
    background-color: #fff;
    .title {
        width: 100%;
        font-size: 16px;
        padding: 15px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        i {
            color: #409eff;
        }
    }
    .table {
        padding: 0 15px;
        padding-bottom: 15px;
    }
}
</style>

<style scoped>
.param-description {
    display: flex;
    align-items: center;
    background-color: #f0f9eb;
    padding: 10px;
    border-radius: 4px;
    border-left: 4px solid #409EFF;
}

.param-description span {
    margin-left: 8px;
    color: #606266;
    font-size: 13px;
}

.member-section {
    margin-top: 16px;

    .form-section {
        background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
        border: 1px solid #e8f0fe;
        border-radius: 8px;
        padding: 18px 24px 4px;
        margin-bottom: 0;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);

        .section-title {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 16px;
            padding-bottom: 10px;
            border-bottom: 1px solid #e8f0fe;

            i {
                font-size: 16px;
                color: #409eff;
            }
        }

        /deep/ .el-form-item__label {
            font-weight: 500;
            color: #606266;
        }

        /deep/ .el-input__inner {
            padding-right: 30px;
        }

        /deep/ .el-input.is-disabled .el-input__inner {
            background: #f5f7fa;
            color: #606266;
        }

        .member-balance {
            display: flex;
            align-items: center;
            gap: 12px;
            min-height: 40px;
            flex-wrap: wrap;
            width: 100%;

            .balance-item {
                background: linear-gradient(135deg, #ecf5ff 0%, #f0f9ff 100%);
                border: 1px solid #b3d8ff;
                border-radius: 4px;
                padding: 5px 14px;
                font-size: 13px;
                color: #303133;
                font-weight: 500;
                white-space: nowrap;
                box-shadow: 0 1px 3px rgba(64, 158, 255, 0.08);
            }
        }
    }
}

.form-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px 24px 4px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

    &--last {
        padding-bottom: 20px;
        margin-bottom: 0;
    }

    .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 18px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f2f3f5;

        i {
            font-size: 16px;
            color: #409eff;
        }
    }

    /deep/ .el-form-item__label {
        font-weight: 500;
        color: #606266;
    }

    /deep/ .el-date-editor {
        width: 100% !important;
    }

    /deep/ .el-input__inner {
        padding-right: 30px;
    }

    .member-balance {
        display: flex;
        align-items: center;
        gap: 16px;
        height: 40px;

        .balance-item {
            background: #f0f9ff;
            border: 1px solid #b3d8ff;
            border-radius: 4px;
            padding: 4px 12px;
            font-size: 13px;
            color: #303133;
            font-weight: 500;
            white-space: nowrap;
        }
    }
}
</style>